__turbopack_context__.v({
  "catalogItem": "catalogItem-module-scss-module__XT4fDW__catalogItem",
  "catalogItemContent": "catalogItem-module-scss-module__XT4fDW__catalogItemContent",
  "catalogItemLabel": "catalogItem-module-scss-module__XT4fDW__catalogItemLabel",
});
